export default [
  { title: 'Add new', icon: 'mdi-plus', action: 'addNew' },
  { title: 'Import', icon: 'mdi-publish' }
];
